import React from "react";
import "./index.css";
import { Link, useLocation } from "react-router-dom";
import logo from "../assets/adt-logo.png";

const Header = () => {
  const location = useLocation();

  return (
    <header className="header flex flexCenter flexRow">
      <div className="logo container-lg flex flexRow">
        <nav className="logoContainer flex flexRow" aria-label="Navegación principal">
          <Link to={"/"}>
            <img src={logo} alt="ADT Alarmas - Alarmita.com" width="140" height="50" />
          </Link>
        </nav>
        {location.pathname === "/" ? (
          <Link to="/cotizador" className="btn">
            Cotizar Alarma
          </Link>
        ) : (
          // sitio seguro box
          <aside className="secureBox" aria-label="Información de seguridad">
            <div className="secureBox__left">
              {/* Candado inline para evitar depender de nuevos assets */}
              <span className="secureBox__icon" aria-hidden="true">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="20"
                  fill="none"
                  viewBox="0 0 16 20"
                >
                  <path
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeMiterlimit="10"
                    strokeWidth="1.5"
                    d="M4 8V5c0-2.21 1.79-4 4-4s4 1.79 4 4v3m-4 5a1 1 0 1 0 0-2 1 1 0 0 0 0 2m0 0v3M2.6 8h10.8c.88 0 1.6.72 1.6 1.6v7c0 1.32-1.08 2.4-2.4 2.4H3.4C2.08 19 1 17.92 1 16.6v-7C1 8.72 1.72 8 2.6 8"
                  ></path>
                </svg>
              </span>
              <div className="secureBox__text">
                <strong>Sitio seguro</strong>
              </div>
            </div>
            <div className="secureBox__right">
              <span className="secureBox__label">Altas Telefónicas:</span>
              <a className="secureBox__tel" href="tel:08102203014" title="Llamar a Altas Telefónicas">
                0810-220-3014
              </a>
            </div>
          </aside>
        )}
      </div>
    </header>
  );
};

export default Header;
